import Middle_Bb from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleBb.mp3";
import Middle_C from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleC.mp3";
import Middle_D from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleD.mp3";
import Middle_Eb from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleEb.mp3";
import Middle_F from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleF.mp3";
import High_G from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_high_G.mp3";
import High_A from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_high_A.mp3";
import High_Bb from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_high_Bb.mp3";
import Low_Bb from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_LowBb.mp3";
import Low_B from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_LowB.mp3";
import High_Ab from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_high_Ab.mp3";
import High_Gb from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_high_Gb.mp3";
import Middle_E from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleE.mp3";
import Middle_Db from "../EARTRAINING/all_chromatic_scales/tenor_sax_chr_scale/tenor_chr_scale_middleDb.mp3";

export const tenorSaxSounds = {
  middle_Bb: new Audio(Middle_Bb),
  middle_C: new Audio(Middle_C),
  middle_D: new Audio(Middle_D),
  middle_Eb: new Audio(Middle_Eb),
  middle_F: new Audio(Middle_F),
  high_G: new Audio(High_G),
  high_A: new Audio(High_A),
  high_Bb: new Audio(High_Bb),
   //for chromatic intervals
   low_Bb: new Audio(Low_Bb),
   low_B: new Audio(Low_B),
   low_Db: new Audio(Middle_Db),
   low_E: new Audio(Middle_E),
   middle_Gb: new Audio(High_Gb),
   middle_Ab: new Audio(High_Ab),
}